import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { resetState, rerenderTable } from './../../store/productBundleTranslations.actions';

// components
import { ModalStepper } from 'dumb';
import ProductBundleTranslationsModalStep from './components/productBundleTranslationsModalStep';

// services
import { addProductBundleTranslations } from './../../productBundleTranslations.service';

// phrases
import phrases from './../../productBundleTranslations.phrases';

const ProductBundleTranslationsModalBatch = ({ id, onClose }) => {
	const modalRef = useRef();
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const batchList = useSelector((store) => store.productBundleTranslations.batchList);

	const onNext = () => {
		setLoading(true);

		const payload = batchList.map((entry) => ({
			bundle: id,
			name: entry.name,
			language: entry.language?.value?.id ?? null,
		}));

		addProductBundleTranslations({ batch: payload })
			.then(() => {
				setLoading(false);
				dispatch(rerenderTable());
				onClose();
			})
			.catch(() => {
				setLoading(false);
			});
	};

	const steps = [
		{
			component: <ProductBundleTranslationsModalStep />,
			title: phrases.MODAL_TITLE,
			onBack: onClose,
			onNext,
			loading,
			isValid: true,
			confirmButtonLabel: phrases.SUBMIT,
			defaultStyles: false,
			noScroll: false,
		},
	];

	useEffect(() => {
		return () => {
			dispatch(resetState());
		};
	}, [dispatch]);

	return (
		<ModalStepper header={phrases.MODAL_TITLE} onClose={onClose} ref={modalRef} isOpen steps={steps} showStep={false} />
	);
};

ProductBundleTranslationsModalBatch.propTypes = {
	onClose: PropTypes.func,
	id: PropTypes.number,
};

export default ProductBundleTranslationsModalBatch;
